import { AuthenticationService } from './../../../services/authentication.service';
import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ReactiveFormsModule, FormsModule, FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ToasterModule, ToasterService, Toast } from 'angular5-toaster';
import { StorageService } from '../../../services/storage.service';
import { User } from '../../../models/user';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-changepass',
  templateUrl: './changepassword.component.html',
  styleUrls: ['./changepassword.component.scss'],
  providers: [AuthenticationService]
})
export class ChangePassComponent implements OnInit {

  public user: User;
  closeResult: string;
  busyChange: boolean = false;
  public errors = null;
  password1;
  password2;

  modalMensaje;
  myform: FormGroup;
  logForm: FormGroup;
  email: string;
  titulo;
  respuesta;

  passwordCambiado;
  ingresarNuevaPassword;
 
  constructor(
    private translate: TranslateService,
    public formBuilder: FormBuilder,
    private storageService: StorageService,
    private _router: Router,
    public activeModal: NgbActiveModal,
    private toasterService: ToasterService,
    private modalService: NgbModal,
    private authenticationService: AuthenticationService
  ) {
    this.translate.get('texto.passwordCambiado').subscribe(
      text => {
        this.passwordCambiado = text;
      });

    this.translate.get('texto.ingresarNuevaPassword').subscribe(
      text => {
        this.ingresarNuevaPassword = text;
      });

  }

  ngOnInit() {
    this.noBack();
    this.user = this.storageService.getCurrentUser();

  }
  

  noBack() {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
  }

  closeModal() {
    this.activeModal.close('cancelar');
  }

  checkPasswordRules(value: string) {
    const val = value || '';

    return {
      minLength: val.length < 14,
      noUppercase: !/[A-Z]/.test(val),
      noLowercase: !/[a-z]/.test(val),
      noNumber: !/[0-9]/.test(val),
      noSpecial: !/[.*@#&!%_+\/\-?^${}()]/.test(val)
    };
  }

  get passwordErrors() {
    const errors = this.checkPasswordRules(this.password1);
    
    // si no hay errores (todos son false), se devuelve null
    return Object.values(errors).includes(true) ? errors : null;
  }

  cambiarPassword(mensaje) {
    const password1 = this.password1;
    const password2 = this.password2;
    const idUser = this.user.userId;
    this.busyChange = true;

    this.authenticationService.cambiarPassword(idUser, password2).subscribe(
      data => {
        this.busyChange = false;
        this.titulo = this.passwordCambiado;
        this.respuesta = data.mensaje;
        this.activeModal.close();
        this.openMensaje(mensaje);
      },
      error => {
        this.busyChange = false;
        if (error.status === 401) {
          this.storageService.openLogout();
        } else {
          console.log(error);
        }
      },
    );
  }


  reiniciar() {
    this.modalMensaje.close();
    this._router.navigate(['/login']);
  }

  openMensaje(mensaje) {
    this.modalMensaje = this.modalService.open(mensaje, { centered: true });
    this.modalMensaje.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReasonFiltersOC(reason)}`;
    });
  }

  private getDismissReasonFiltersOC(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }


}






// WEBPACK FOOTER //
// ./src/app/pages/home/changepassword/changepassword.component.ts